import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface CategoryScopeListPageProps extends NSARouterMakerResult, FieldProps { }

export default function CategoryScopeListPage(props: CategoryScopeListPageProps)
{
	return (
		<FieldLayout
			{...props}
			action={{
				description: "This section displays all category scopes you have created with their basic information."
			}}
			pages={{
				entity: FieldEntities.category_scope(props),
				list: {}
			}}
		>
			<>
			</>
		</FieldLayout>
	);
}